import { DefaultResponseWithData } from "./system";
import { BaseEntity } from "./system";

export interface ISettingsResponse extends DefaultResponseWithData<ISetting[]> { }

export interface ISingleSettingResponse extends DefaultResponseWithData<ISetting> { }

export interface ISetting extends BaseEntity {
  key: string;
  value: string;
  userId: string;
  settingType: SettingType;
  required: boolean;
  inputType: SettingInputType;
}

export enum SettingType {
  General,
  Shipping
}

export enum SettingInputType {
  Text,
  Toggle,
  Number
}
